import React from "react"
import { DefaultFooter } from "@ant-design/pro-layout"
import options from "../../config/options"
import { Divider } from "antd"
import {
  MailOutlined,
  FacebookOutlined,
  PhoneOutlined,
} from "@ant-design/icons"

const FooterDefault = () => {
  return (
    <>
      <Divider className="footerDivider" dashed />
      <DefaultFooter
        copyright={`Websitecafe. All rights reserved.`}
        links={[
          {
            key: "Email",
            title: (
              <MailOutlined style={{ fontSize: "16px", color: "#212B3C" }} />
            ),
            href: options.mailCTA,
            blankTarget: true,
          },
          {
            key: "Facebook",
            title: (
              <FacebookOutlined
                style={{ fontSize: "16px", color: "#212B3C" }}
              />
            ),
            href: options.facebookUrl,
            blankTarget: true,
          },
          {
            key: "Phone",
            title: (
              <PhoneOutlined style={{ fontSize: "16px", color: "#212B3C" }} />
            ),
            href: options.telCTA,
            blankTarget: true,
          },
        ]}
      />
    </>
  )
}

export default FooterDefault
